import api from '@/services/api';
// default subscription
function createSubscription(subscription) {
  return api().post('subscriptions', subscription);
}

function getSubscriptionFromId(id) {
  return api().get(`subscriptions/${id}`);
}

function modifySubscription(id, subscription) {
  return api().put(`subscriptions/${id}`, subscription);
}

function deleteAmendment({ subscriptionId }) {
  return api().put(`subscriptions/${subscriptionId}/revert`);
}

// subscription declaration
function findDeclarationBySubscriptionId(subscriptionId) {
  return api().get(`subscriptions/${subscriptionId}/declarations`);
}

// subscription update
function updateSubscription(subscriptionId, body) {
  return api().patch(`subscriptions/${subscriptionId}/update_price`, body);
}

function updateSubscriptionRisk(subscriptionId, body) {
  return api().patch(`subscriptions/${subscriptionId}/update_risk`, body);
}

// subscription validation
function validateSubscription(subscriptionId) {
  return api().get(`subscriptions/${subscriptionId}/validate`);
}

// subscription claim
function sendClaimEmail(formData, policyId) {
  return api().post(`policies/${policyId}/claims`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

// subscription document
function uploadDocuments(body) {
  return api().post('documents', body);
}

// subscription changes
function findAmendmentChangesBySubscriptionId(subscriptionId) {
  return api().get(`subscriptions/${subscriptionId}/changes`);
}

// validate declaration
function validateSubscriptionDeclaration(subscriptionId) {
  return api()
    .put(`subscriptions/${subscriptionId}/lead_status`, {
      leadStatus: 'DECLARATION_ACCEPTED',
    });
}

// apply amendment (ACCORD_CLIENT)
function applyAmendment(subscriptionId, effectiveDate) {
  return api().put(`subscriptions/${subscriptionId}/lead_status`, {
    leadStatus: 'ACCORD_CLIENT',
    effectiveDate,
  });
}

// create employee travel and generate visa attestation
function createEmployeeTravelCertificate(subscriptionId, employeeTravelRequest) {
  return api().post(`subscriptions/${subscriptionId}/employee_travels`, employeeTravelRequest);
}

export {
  createSubscription,

  deleteAmendment,

  modifySubscription,

  updateSubscription,
  updateSubscriptionRisk,

  sendClaimEmail,

  getSubscriptionFromId,
  findDeclarationBySubscriptionId,

  findAmendmentChangesBySubscriptionId,

  validateSubscription,
  validateSubscriptionDeclaration,
  applyAmendment,

  uploadDocuments,

  createEmployeeTravelCertificate,
};
